import { HStack, Text } from '@chakra-ui/react';

import type { DefaultTFuncReturn } from 'i18next';

interface CompletionStatusTagProps {
  statusData:
    | {
        statusText: DefaultTFuncReturn | undefined;
        status: 'completed' | 'completedOverdue' | 'overdue' | 'notStarted' | undefined;
      }
    | undefined;
}

export default function CompletionStatusTag({ statusData }: CompletionStatusTagProps) {
  const statusStylesMap = {
    completed: {
      borderColor: '#2CBE75',
      textColor: '#2CBE75',
    },
    completedOverdue: {
      borderColor: 'red.200',
      textColor: 'red.300',
    },
    overdue: {
      borderColor: 'red.100',
      textColor: 'red.400',
    },
    notStarted: {
      borderColor: 'neutral.100',
      textColor: 'neutral.600',
    },
  };

  if (!statusData || !statusData.statusText || !statusData.status) {
    return null;
  }

  return (
    <HStack
      paddingY={1}
      paddingX={2}
      fontSize="10px"
      fontWeight={600}
      textTransform="uppercase"
      border="1px solid"
      borderColor={statusStylesMap[statusData.status].borderColor}
      borderRadius="4px"
      backgroundColor={statusData.status === 'overdue' ? 'red.0' : 'transparent'}
    >
      <Text color={statusStylesMap[statusData.status].textColor}>{statusData.statusText}</Text>
    </HStack>
  );
}
